import { Navigate, useLocation } from "react-router-dom";

/** يطابق `hr-web-main`: `/apply-job` → `/apply-job/start` مع الحفاظ على الاستعلام */
export default function ApplyJobIndexRedirect() {
  const { search } = useLocation();
  return (
    <Navigate to={`start${search}`} replace relative="path" />
  );
}
